







































import { Component, Vue } from "vue-property-decorator";
import Chime from "@/resources/mixins/chime/chime";
import { mixins } from "vue-class-component";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
@Component({
  name: "background-image-component",
})
export default class ConfigDevicesComponent extends mixins(LoadApp, Chime) {
  images = [
    require("@/assets/images/background/bg_remove.jpg"),
    require("@/assets/images/city.jpg"),
    require("@/assets/images/city2.jpg"),
    require("@/assets/images/background/bg_nubi_dark.jpg"),
    require("@/assets/images/background/bg_nubi_light.jpg"),
    require("@/assets/images/background/bg_nubi_dark_white.jpg"),
  ];
  get imageActive(): string {
    return this.$store.getters["MeetingStore/getBackgroundImage"];
  }
  get active(): boolean {
    return this.$store.getters["MeetingStore/getOpenBackgroundImages"];
  }
  set active(e: boolean) {
    if (!e) this.onClose();
  }

  setBackground(image) {
    if (image === require("@/assets/images/background/bg_remove.jpg")) {
      this.stopBackground();
    } else {
      this.addBackgroundImage(image);
    }
    setTimeout(() => this.onClose(), 500);
  }

  onClose() {
    this.$store.dispatch("MeetingStore/setOpenBackgroundImagesAction", false);
  }
}
